"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialButton = SocialButton;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("./constants");
var styles = _interopRequireWildcard(require("./SocialButton.css"));
var buttonStyles = _interopRequireWildcard(require("../../styles/button.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SocialButton(_ref) {
  let {
    type,
    onClick
  } = _ref;
  const settings = _constants.SOCIALS_SETTINGS_MAP[type];
  const handleClick = React.useCallback(() => onClick(type), [type, onClick]);
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    title: settings.title,
    "data-mark": `SocialBtn${type[0].toUpperCase()}${type.slice(1).toLowerCase()}`,
    className: (0, _classnames.default)(buttonStyles['button'], styles['button'], settings.className),
    style: {
      backgroundImage: `url("${settings.icon}")`
    },
    onClick: handleClick
  });
}